// Compartilhado entre componentes: o mixin é instanciado em cada um.
let ultimoAvisoSessao = 0

export const trataErro = {
  created () {
  },
  methods: {
    trataErro (error) {
      let mensagem = null
      //
      // Erro que não veio do axios (ex.: TypeError lançado dentro do .then())
      // não tem `response` nem `request`. Sem esse desvio no início, a própria
      // trataErro quebrava em `error.response.status` e escondia o erro real.
      if (!error || (!error.response && !error.request)) {
        mensagem = (error && error.message) ? error.message : 'Erro inesperado no processamento da tela'
        this.$snotify.error(mensagem, {bodyMaxLength: 1200})
        console.error('%cErro:', 'font-size: 20px; background: red; color: white', error)
        return mensagem
      }
      //
      if (!error.response) {
        // Requisição feita, sem resposta do servidor
        mensagem = 'Nenhum registro encontrado'
      } else if (error.response.status === 403) {
        mensagem = _.get(error, 'response.data.message', 'Acesso negado')
      } else if (error.response.status === 503) {
        mensagem = 'Sistema esta em manutenção favor acessar novamente daqui a alguns segundos. Obrigado'
      } else if (error.response.status === 422) {
        // Suporte 79069 - antes só era lido `response.data.error`. O 422 padrão do Laravel
        // (ValidationException) devolve `errors`, no plural: o _.get caía no default {}, a mensagem
        // virava [] e o snotify pintava uma tarja vermelha sem texto nenhum - o usuário via que algo
        // falhou e não sabia o quê. Agora os dois formatos são aceitos e, se mesmo assim não houver
        // nada para mostrar, cai no `message` do corpo ou num texto genérico.
        let erros = _.get(error, 'response.data.error', null) || _.get(error, 'response.data.errors', null) || {}
        mensagem = _.flattenDeep(Object.values(erros))
        mensagem = _.isEmpty(mensagem)
          ? _.get(error, 'response.data.message', 'Dados inválidos. Revise os campos informados.')
          : _.join(mensagem, ' ')
      } else if (error.response.status === 401) {
        // Um 401 que chega aqui já passou pelo interceptor de renovação
        // (src/auth.js): ou não havia refresh token, ou ele foi recusado, e a
        // sessão já foi encerrada com redirecionamento para o login. Aqui só
        // avisa o usuário — sem mexer no localStorage nem recarregar a página.
        mensagem = 'Sua sessão expirou. Faça login novamente.'

        // As telas disparam várias requisições juntas e cada 401 chegava aqui,
        // empilhando caixas iguais. Um aviso basta.
        let agora = new Date().getTime()

        if (agora - ultimoAvisoSessao < 10000) {
          return mensagem
        }

        ultimoAvisoSessao = agora
      } else if (error.response.status === 500) {
        if (_.get(error, 'response.data.error')) {
          mensagem = 'Erro no processamento da requisição. ' + error.response.data.error
        } else if (_.get(error, 'response.data.message')) {
          mensagem = 'Erro no processamento da requisição. ' + error.response.data.message
        } else {
          mensagem = 'Erro no processamento da requisição. ' + error.response.data
        }
      } else if (error.response.status === 409) {
        mensagem = _.get(error, 'response.data.responseInfo.reasons[0].detail', 'Conflito no processamento da requisição')
      } else {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        mensagem = error.response.data
      }
      this.$snotify.error(mensagem, {bodyMaxLength: 1200}) // primeira parte é a mensagem depois a configuração padrão
      console.log('%cErro:', 'font-size: 20px; background: red; color: white', error.response)

      return mensagem
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/trataResponseErro.js